import React from 'react';
import { Link } from 'react-router-dom';
import { MobileLayout } from '../../components/MobileLayout';
import { Card, CardHeader, CardContent } from '../../components/ui/Card';
import { usePlatform } from '../../context/PlatformContext';
import { MapPin, ClipboardList, FileText, Layers, ArrowRight, TrendingUp, Clock } from 'lucide-react';
export function CmDashboardPage() {
  const {
    jobs
  } = usePlatform();
  const daAssegnare = jobs.filter(j => j.status === 'da_assegnare');
  const oggi = jobs.filter(j => j.date === 'Oggi');
  const liveStats = [{
    label: 'Opportunità di zona',
    value: '4',
    to: '/cm/opportunita'
  }, {
    label: 'Incarichi oggi',
    value: `${oggi.length}`,
    to: '/cm/incarichi'
  }, {
    label: 'Da assegnare',
    value: `${daAssegnare.length}`,
    to: '/cm/incarichi'
  }, {
    label: 'Cleaner attivi',
    value: '4',
    to: '/cm/team'
  }];
  const jobStatusLabel: Record<string, {
    label: string;
    cls: string;
  }> = {
    da_assegnare: {
      label: 'Da assegnare',
      cls: 'bg-amber-50 text-amber-700 border-amber-200'
    },
    assegnata: {
      label: 'Assegnata',
      cls: 'bg-muted text-muted-foreground border-border'
    },
    in_corso: {
      label: '● In corso',
      cls: 'bg-coral/5 text-coral border-coral/20'
    },
    completata: {
      label: 'Completata',
      cls: 'bg-emerald-50 text-emerald-700 border-emerald-200'
    }
  };
  return <MobileLayout data-id="element-1727">
      {/* Header */}
      <div className="mb-6" data-id="element-1728">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-1729">
          Ciao, Cleaner Manager 👋
        </h1>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6" data-id="element-1730">
        {liveStats.map(s => <Link key={s.label} to={s.to} className="bg-white border border-border rounded-xl p-4 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-1731">
            <div className="text-2xl font-bold text-foreground" data-id="element-1732">{s.value}</div>
            <div className="text-xs text-muted-foreground mt-1" data-id="element-1733">{s.label}</div>
          </Link>)}
      </div>

      {/* Highlight: zone opportunity */}
      <Link to="/cm/opportunita" className="block bg-white border border-border rounded-xl p-5 mb-6 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-1734">
        <div className="flex items-start gap-4" data-id="element-1735">
          <div className="w-12 h-12 rounded-xl bg-coral/10 flex items-center justify-center flex-shrink-0" data-id="element-1736">
            <Layers size={24} className="text-coral" data-id="element-1737" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-1738">
            <div className="flex items-center gap-2 mb-1" data-id="element-1739">
              <h2 className="text-sm font-semibold text-foreground" data-id="element-1740">
                4 pulizie aggregabili ai Navigli
              </h2>
              <span className="text-[10px] font-medium text-coral bg-coral/10 px-1.5 py-0.5 rounded-full" data-id="element-1741">
                NUOVO
              </span>
            </div>
            <p className="text-xs text-muted-foreground" data-id="element-1742">
              Entro 1,2 km · Ven 24 – Sab 25 Gen · efficienza stimata +18%
            </p>
            <div className="flex items-center gap-1 text-sm font-medium text-coral mt-2" data-id="element-1743">
              Invia una proposta
              <ArrowRight size={15} data-id="element-1744" />
            </div>
          </div>
        </div>
      </Link>

      {/* Today jobs */}
      <Card className="mb-6" data-id="element-1745">
        <CardHeader icon={<ClipboardList size={15} className="text-muted-foreground" data-id="element-1747" />} title="Incarichi di oggi" action={<Link to="/cm/incarichi" className="text-xs font-medium text-coral hover:underline" data-id="element-1748">
              Vedi tutti
            </Link>} data-id="element-1746" />
        <CardContent data-id="element-1749">
          {oggi.length === 0 && <p className="text-sm text-muted-foreground text-center py-4" data-id="element-1750">
              Nessun incarico per oggi.
            </p>}
          <ul className="space-y-3" data-id="element-1751">
            {oggi.map(j => <li key={j.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-1752">
                <div className="min-w-0" data-id="element-1753">
                  <div className="text-sm font-semibold text-foreground truncate" data-id="element-1754">
                    {j.apartmentName}
                  </div>
                  <div className="flex items-center gap-2 text-xs text-muted-foreground mt-0.5" data-id="element-1755">
                    <Clock size={12} data-id="element-1756" />
                    {j.time}
                    <span data-id="element-1757">·</span>
                    {j.cleanerName ?? 'Da assegnare'}
                  </div>
                </div>
                <span className={`text-[10px] font-medium px-2 py-1 rounded-full border flex-shrink-0 ${jobStatusLabel[j.status].cls}`} data-id="element-1758">
                  {jobStatusLabel[j.status].label}
                </span>
              </li>)}
          </ul>
        </CardContent>
      </Card>

      {/* Earnings teaser */}
      <Link to="/cm/guadagni" className="block bg-white border border-border rounded-xl p-5 hover:border-coral/50 hover:shadow-sm transition-all" data-id="element-1759">
        <div className="flex items-center justify-between" data-id="element-1760">
          <div className="flex items-center gap-3" data-id="element-1761">
            <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-1762">
              <TrendingUp size={20} className="text-navy" data-id="element-1763" />
            </div>
            <div data-id="element-1764">
              <div className="text-sm font-semibold text-foreground" data-id="element-1765">
                Guadagni stimati questo mese
              </div>
              <div className="text-xs text-muted-foreground" data-id="element-1766">
                Su contratti e interventi confermati
              </div>
            </div>
          </div>
          <div className="text-lg font-bold text-coral" data-id="element-1767">€4.280</div>
        </div>
      </Link>
    </MobileLayout>;
}